const NOME_PROJETO = 'KCC';
const TEXTO_SEM_DADOS = 'Sem dados para exibir';

export { NOME_PROJETO, TEXTO_SEM_DADOS };
